import React, {Component} from 'react';
import { Checkbox } from 'react-icheck';
import PublicStore from '../../stores/PublicStore'
import IframeModal from 'component/element/IframeModal'
import './tos.css'
import {connect} from 'react-redux'
class TermOfServiceModal extends Component {

    constructor(props) {
      super(props)

      this.state = {}
    }

    componentDidMount() {
        // this.loadData()
    }

    componentWillReceiveProps(newProps) {
        // if (newProps.show && newProps.show !==this.props.show) {
            
        // }
    }

    loadData() {
        let url = PublicStore.getTermOfServiceUrl()
        this.refs.iframeTOS.loadUrl(url)
    }

    onConfirmClick(callBack) {
        PublicStore.tosAccept((result)=>{
            callBack()
            if (this.props.onAcceptClick!=undefined)
                this.props.onAcceptClick()
        },()=>{
            callBack()
        })
    }

    renderCustom(){
        let {messages} = this.props
        return (<div className='pull-left'>
            <Checkbox					
					checked={true}
					checkboxClass="icheckbox_square-blue"
					increaseArea="20%"
					label={''}
				/> {messages['Read Accept']} 
            <a href="https://www.bigfix.co/privacy/privacy.html" target="_blank" > {messages['Read Accept2']}</a>
        </div>)
    }

    render() {
        return(
            <div >
                <IframeModal 
                    ref='iframeTOS' 
                    title={this.props.messages['Terms And Conditions']} 
                    modal={true} 
                    footer={true}
                    style={'tos'}
                    renderCustomFooter={this.renderCustom.bind(this)}                
                    onConfirmClick={this.onConfirmClick.bind(this)}
                />
            </div>
        )
    }
}

TermOfServiceModal.defaultProps = {
    
}

export default connect(
    (state) => ({messages: state.message.view.tos.TermOfServiceModal}),null,null,{withRef:true},
)(TermOfServiceModal);



// WEBPACK FOOTER //
// ./src/view/tos/TermOfServiceModal.js